var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-avatar-labeled',{attrs:{"label":_vm.invite.email,"src":_vm.invite.avatarUrl,"alt":_vm.invite.email,"size":_vm.$options.avatarSize,"entity-name":_vm.invite.email,"entity-id":_vm.member.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }